
export interface RegisterProps {
  id: string;
  receivingTitle: string;
  type: string;
  sender_Details: string;
  courier?: string;
  courier_Number?: string;
  mode_of_transport: string;
  mode_of_transport_number: string;
  date: string;
  receiver_Description: string;
  barcode_Package: string;
  isActive: boolean;
  isDeleted: boolean;
  verify_Status: string;
  customer_Name: string;
  // files: FileUploadInterface[];
  vaultlocation?: string;
  description: string;
  barcode?: string;
}

export const CRMRegisterIntialState = {
  id: '',
  receivingTitle: '',
  type: '',
  sender_Details: '',
  mode_of_transport: '',
  mode_of_transport_number: '',
  date: '',
  receiver_Description: '',
  barcode_Package: '',
  verify_Status: 'Not Verified',
  customer_Name: '',
  isActive: false,
  isDeleted: false,
  // files: [],
  vaultlocation: '',
  description: '',
  barcode: '',
};

interface Option {
  optionId: string;
  optionIndex: number;
  optionName: string;
  optTemplateId: string;
  optionDateTime: string;
  optionLinkId: string;
  optionLinkName: string;
  listOfOptions: Option[]; // Assuming it can be an array of Option
  optionType?: string; // Assuming optionType can be a string
  isActive: boolean;
  isMulti: boolean;
  isDisabled: boolean;
  isDeleted: boolean;
  isSelected: boolean;
}

interface SelectedMaster {
  id: string;
  masterId?: string; // Optional field
  name?: string; // Optional field
  options: Option[];
}

interface DropdownWithTab {
  id: string;
  selectedMaster: SelectedMaster;
  childLinks: any[]; // Assuming it's an array, you can define it more specifically
  selectedMasterId: string;
}

export interface CRM_Metadata {
  elementId: string;
  elementIndex: number;
  templateElementId: string;
  elementName: string;
  elementValue: string;
  selectMasterComponent?: any; // Assuming it's optional and can be more specific
  metadatatype: string;
  elementType: string;
  parentId: string;
  parentName?: string;
  dynamicTypeName?: string;
  dynamicTypeId?: string;
  creatorName: string;
  elementDateTime: string;
  masterId?: string;
  enableByDefault: boolean;
  validation?: string;
  flexBasis?: string;
  isMandatory: boolean;
  readOnly: boolean;
  isActive: boolean;
  hasChild: boolean;
  isDeleted: boolean;
  isMultiple: boolean;
  metadataFromParent?: string;
  options: Option[];
  files: any[]; // Assuming it's an array, you can define it more specifically
  photos: any[]; // Assuming it's an array, you can define it more specifically
  dropdownWithTab: DropdownWithTab;
  ddwTabId: string;
}

export const CRM_MetadataInitialState: CRM_Metadata = {
  elementId: '',
  elementIndex: 0,
  templateElementId: '',
  elementName: '',
  elementValue: '',
  selectMasterComponent: null,
  metadatatype: '',
  elementType: '',
  parentId: '',
  parentName: undefined,
  dynamicTypeName: undefined,
  dynamicTypeId: undefined,
  creatorName: '',
  elementDateTime: '',
  masterId: undefined,
  enableByDefault: false,
  validation: undefined,
  flexBasis: undefined,
  isMandatory: false,
  readOnly: false,
  isActive: false,
  hasChild: false,
  isDeleted: false,
  isMultiple: false,
  metadataFromParent: undefined,
  options: [],
  files: [],
  photos: [],
  dropdownWithTab: {
    id: '00000000-0000-0000-0000-000000000000',
    selectedMaster: {
      id: '00000000-0000-0000-0000-000000000000',
      masterId: undefined,
      name: undefined,
      options: [],
    },
    childLinks: [],
    selectedMasterId: '00000000-0000-0000-0000-000000000000',
  },
  ddwTabId: '00000000-0000-0000-0000-000000000000',
};

export interface crmRegister {
  title:string;
  type:string;
  barcode:string;
  date:string;
  description:string;
  mode_of_Transport:string;
  mode_of_Transport_Number:string;
  sender_Details:string;
  files: any[];
  metadata: CRM_Metadata[];
}

export const crmRegisterIntialState = {
  title:'',
  type:'',
  barcode:'',
  date:'',
  description:'',
  mode_of_Transport:'',
  mode_of_Transport_Number:'',
  sender_Details:'',
  files: [],
  metadata: []
};


export const returntaskStatus = (number: number) => {
  switch (number) {
    case 0:
      return 'Yet to start';
    case 1:
      return 'Start';
    case 2:
      return 'Complete';
    case 3:
      return 'Hold';
    case 4:
      return 'Resume';
    case 5:
      return 'Reject';
    case 6:
      return 'Rework';
    case 7:
      return 'Resolve';
    default:
      return '';
  }
}

export interface listObject {
  id: string;
  value: string;
}

export const templateL2Info = [
  { 
    task:'Authorization',
    roleId:'SMAU01'
  },
  { 
    task:'Logistics',
    roleId:'SMLO01'
  },
  { 
    task:'Process',
    roleId:'SMPR01'
  },
]

export const metadataDetails = ["No Of Reel","Duration (In Minutes)","Color / B&W","Estimate(Hours)","Estimate Cost","Delivery Date","Process","Client Name","InWard Remarks","OutWard Remarks"];
export const sortNameReset = {
  'Company':'company',
  'Building':'building',
  'Department':'department',
  'New Asset Tag':'new_asset_tag',
  'Floor':'floor',
  'Rack no':'rack_no',
  'Category':'category',
  'Capacity':'capacity',
  'Location':'location',
  'Make Or Model No':'make_Or_Model_No',
  'Model SN':'model_sn',
  'QR code': 'qr_Code',
  'User Or Owner Name':'user_Or_Owner_Name',
  'Remarks':'remarks'
}


export const handleFindDifferences = (localMetadata:CRM_Metadata[],originalMetadata:CRM_Metadata[]) =>{
  const lookup = originalMetadata.reduce((acc:any, item:any) => {
      acc[item.elementId] = item.elementValue;
      return acc;
  }, {});
  return localMetadata
      .filter((item1:any) => {
          const value2 = lookup[item1.elementId];
          return value2 && item1.elementValue !== value2;
      })
      .map((item1:any) => ({
          elementId: item1.elementId,
          elementName: item1.elementName,
          elementValue: item1.elementValue,
      }));
}


export const buildingOptions = [
       { key: 'pvd', value: 'PVD', text: 'PVD' },
       { key: 'efxresto', value: 'EFX Resto', text: 'EFX Resto' },
       { key: 'Colorisation', value: 'Colorisation', text: 'Colorisation' },
];


export const categoryOptions = [
       { key: 'hardisk', value: 'HDD', text: 'HDD' },
       { key: 'lto', value: 'LTO', text: 'LTO' },
       { key: 'filmreels', value: 'Film Reels', text: 'Film Reels' },
       { key: 'tapes', value: 'Tapes', text: 'Tapes' },
       { key: 'photos', value: 'Photos', text: 'Photos' },
       { key: 'dvd', value: 'DVD', text: 'DVD' },
       { key: 'digitalassets', value: 'Digital Assets', text: 'Digital Assets' },
];

export const locationOptions = [
       { key: 'chennai', value: 'Chennai', text: 'Chennai' },
       { key: 'hyderabad', value: 'Hyderabad', text: 'Hyderabad' },
       { key: 'pune', value: 'Pune', text: 'Pune' },
]

export const searchFields = [
       "title",
       "company",
       "building",
       "department",
       "location",
       "category",
       "make_Or_Model_No",
       "model_Sn",
       "asset_Moved_To",
];
    
export const handleDateFormat = (value: Date) => {
  if (value instanceof Date) {
    const month = (value.getMonth() + 1).toString().padStart(2, '0');
    const day = value.getDate().toString().padStart(2, '0');
    const year = value.getFullYear();
    return `${month}-${day}-${year}`;
  }
  return value || '';
};



export const formFields = [
  {
    name: 'title',
    label: 'Title',
    type: 'input',
    placeholder: 'Enter Title',
  },
  {
    name: 'company',
    label: 'Company',
    type: 'input',
    placeholder: 'Enter Company',
  },
  {
    name: 'building',
    label: 'Building',
    type: 'dropdown',
    placeholder: 'Select Building',
    options: buildingOptions,
  },
  {
    name: 'department',
    label: 'Department',
    type: 'dropdown',
    placeholder: 'Select Department',
    options: [],
  },
  {
    name: 'location',
    label: 'Location',
    type: 'dropdown',
    placeholder: 'Select Location',
    options: locationOptions,
  },
  {
    name: 'category',
    label: 'Category',
    type: 'dropdown',
    placeholder: 'Select Category',
    options: categoryOptions,
  },
  {
    name: 'make_Or_Model_No',
    label: 'Make or Model No.',
    type: 'input',
    placeholder: 'Enter Title',
  },
  {
    name: 'model_Sn',
    label: 'Model Sn.',
    type: 'input',
    placeholder: 'Enter Title',
  },
  {
    name: 'asset_Moved_To',
    label: 'Asset Moved To',
    type: 'dropdown',
    placeholder: 'Select Asset Moved To',
    options: [],
  },
  {
    name: 'receiving_date',
    label: 'Receiving Date',
    type: 'date',
    placeholder: 'Select Received Date',
  },
  {
    name: 'handover_date',
    label: 'Handover Date',
    type: 'date',
    placeholder: 'Select Handover Date',
  },
  {
    name: 'remarks',
    label: 'Remarks',
    type: 'input',
    placeholder: 'Enter Remarks',
  },
];

export const reAllocationInitialState = {
  itemId:'',
  userId: '',
  employeeId:'',
  employeeName:'',
  startFrame:'',
  endFrame:'',
  totalFrame:''
}

export interface reAllocationTypes {
  itemId:string,
  userId: string,
  employeeId:string,
  employeeName:string,
  startFrame:string,
  endFrame:string,
  totalFrame:string
}

export interface cutlistCompleteTypes {
  title: string,
  reelName: string,
  empId: string,
  previousOwnerEmployeeID:string,
}

export const cutlistCompleteInitialState = { 
  title: "",
  reelName: "",
  empId: "",
  previousOwnerEmployeeID: ""
}